var map = {
	"./50-beaches.mp4": "QQdC",
	"./easy.mp4": "RJJy",
	"./featured-video.mp4": "xZFP",
	"./it-takes-an-island.mp4": "zlIH",
	"./make-it-zero.mp4": "gKAI",
	"./video.mp4": "V0Cn"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ip+z";